import EtchRichText from './EtchRichText.component';

export default EtchRichText;